import axios from 'axios';
var isoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?([+-][0-2]\d:[0-5]\d)?Z?$/;
var api = axios.create({
    baseURL: process.env.REACT_APP_API_ENDPOINT,
});
function isIsoDateString(value) {
    return value && typeof value === "string" && isoDateFormat.test(value);
}
export function convertISODateStringsToDates(body) {
    if (body === null || body === undefined || typeof body !== "object")
        return body;
    for (var _i = 0, _a = Object.keys(body); _i < _a.length; _i++) {
        var key = _a[_i];
        var value = body[key];
        if (isIsoDateString(value))
            body[key] = new Date(value);
        else if (typeof value === "object")
            convertISODateStringsToDates(value);
    }
}
api.interceptors.request.use(function (config) {
    var token = localStorage.getItem('token');
    if (token) {
        if (!config.headers) {
            // @ts-ignore
            config.headers = {};
        }
        config.headers['Authorization'] = token;
    }
    return config;
});
api.interceptors.response.use(function (originalResponse) {
    convertISODateStringsToDates(originalResponse.data);
    return originalResponse;
});
export default api;
